import { render, staticRenderFns } from "./NovasConfiguracoes.vue?vue&type=template&id=20f4f170"
import script from "./NovasConfiguracoes.vue?vue&type=script&lang=js"
export * from "./NovasConfiguracoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports